export const excludeParlorList = [
  "76",
  "194",
  "229",
  "247",
  "262",
  "325",
  "326",
  "402",
  "585",
  "595",
  "611",
  "641",
  "792",
  "863",
  "996",
];

export const excludeFacilities = [
  "5",
  "33",
  "174",
  "200",
  "232",
  "702",
  "832",
  "1028",
];
